export const isCompanyEmail = (email) => {
  if (!email) return false;

  const blacklist = process?.env?.RAZZLE_RUNTIME_BLACKLIST_DOMAINS?.split(',') ?? [];
  const emailSplit = email.split('@');
  const domain = emailSplit[emailSplit.length - 1];
  const domainSplit = domain.split('.');
  const domainToValidate = domainSplit[0]?.toLowerCase();
  return !blacklist.includes(domainToValidate);
};

export const errorsReasonSendgrid = [
  'Bounced Address',
  'Receiving server temporarily rejected the message',
  '500 unknown recipient',
];

export const styleEmailPreviewListItems = (previewDiv) => {
  if (!previewDiv) return;

  const listItems = previewDiv.getElementsByTagName('li');
  Array.from(listItems).forEach((li) => {
    li.style.marginLeft = '20px';
    li.style.listStylePosition = 'inside';
  });
};

export function isValidEmail(email) {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
}
